import { faEllipsis, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Badge, IconButton, Popover } from "@mui/material";
import React, { useState } from "react";
import { FileIcon, DefaultExtensionType } from "react-file-icon";
import { useTranslation } from "react-i18next";
import { Props, State } from "./interfaces";
import { FileIconButton } from "./styles";

import { fileSize } from "../../containers/Document/NewFile/utils";
import { customFileIconStyles } from "../../reusable-components/DefaultFileIconStyles/default-file-icon-styles";
import DocumentViewer from "../../reusable-components/DocumentViewer/DocumentViewer";
import { READABLE_FILE_TYPES, READABLE_IMAGE_TYPES } from "../../reusable-components/DocumentViewer/fileTypes";
import SimplePopover from "../../reusable-components/SimplePopover/SimplePopover";
import { handleDownloadFile } from "../../services/documents/document-files-api.service";
import { getFileExtension } from "../../utils/files-utils/get-file-extension";

import { intlFormatDateWithHour } from "../../utils/time-utils";

const AttachedFiles = ({ document, numberOfFilesToDisplay = 3, customFileName }: Props) => {
  const { t } = useTranslation();

  const [state, setState] = useState<State>({
    isViewing: false,
    currentFile: null,
  });

  return (
    <Grid>
      {document?.files && (
        <>
          {document.files.slice(0, numberOfFilesToDisplay).map((file) => {
            const fileExtension = getFileExtension(file.name).toLowerCase();

            return (
              <React.Fragment key={file.id}>
                {!READABLE_FILE_TYPES.includes(fileExtension) && !READABLE_IMAGE_TYPES.includes(fileExtension) && (
                  <FileIconButton
                    title={`"${file.name}" ${fileSize(file.size)} ${t("common_words.user")} ${
                      file.createdByUser?.name ?? file.createdByUser?.email ?? ""
                    } ${intlFormatDateWithHour(file.createdAt)}`}
                    onClick={() => handleDownloadFile(file, customFileName)}
                  >
                    <FileIcon
                      extension={fileExtension}
                      {...customFileIconStyles[fileExtension as DefaultExtensionType]}
                      radius={3}
                    />
                  </FileIconButton>
                )}

                {(READABLE_FILE_TYPES.includes(fileExtension) || READABLE_IMAGE_TYPES.includes(fileExtension)) && (
                  <FileIconButton
                    onClick={() => {
                      setState((state) => ({
                        ...state,
                        isViewing: true,
                        currentFile: file,
                      }));
                    }}
                  >
                    <FileIcon
                      extension={fileExtension}
                      {...customFileIconStyles[fileExtension as DefaultExtensionType]}
                      radius={3}
                    />
                  </FileIconButton>
                )}
              </React.Fragment>
            );
          })}

          {document?.files.length > numberOfFilesToDisplay && (
            <Badge>
              <SimplePopover
                buttonType="icon"
                buttonContent={<FontAwesomeIcon icon={faEllipsis} />}
                flow="row"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
              >
                {document?.files.slice(numberOfFilesToDisplay).map((file) => {
                  const fileExtension = getFileExtension(file.name).toLowerCase();

                  return (
                    <React.Fragment key={file.id}>
                      {!READABLE_FILE_TYPES.includes(fileExtension) &&
                        !READABLE_IMAGE_TYPES.includes(fileExtension) && (
                          <FileIconButton
                            title={`"${file.name}" ${fileSize(file.size)} ${t("common_words.user")} ${
                              file.createdByUser?.name ?? file.createdByUser?.email ?? ""
                            } ${intlFormatDateWithHour(file.createdAt)}`}
                            onClick={() => handleDownloadFile(file, customFileName)}
                          >
                            <FileIcon
                              extension={fileExtension}
                              {...customFileIconStyles[fileExtension as DefaultExtensionType]}
                              radius={3}
                            />
                          </FileIconButton>
                        )}

                      {(READABLE_FILE_TYPES.includes(fileExtension) ||
                        READABLE_IMAGE_TYPES.includes(fileExtension)) && (
                        <FileIconButton
                          onClick={() => {
                            setState((state) => ({
                              ...state,
                              isViewing: true,
                              currentFile: file,
                            }));
                          }}
                        >
                          <FileIcon
                            extension={fileExtension}
                            {...customFileIconStyles[fileExtension as DefaultExtensionType]}
                            radius={3}
                          />
                        </FileIconButton>
                      )}
                    </React.Fragment>
                  );
                })}
              </SimplePopover>
            </Badge>
          )}

          {!!state.currentFile && (
            <Popover
              open={state.isViewing}
              anchorPosition={{ left: 0, top: 0 }}
              anchorReference={"anchorPosition"}
            >
              <IconButton
                onClick={() => {
                  setState({
                    ...state,
                    isViewing: false,
                    currentFile: null,
                  });
                }}
              >
                <FontAwesomeIcon icon={faClose} />
              </IconButton>
              {state.currentFile && (
                <DocumentViewer
                  fileDto={state.currentFile}
                  customFileName={customFileName}
                />
              )}
            </Popover>
          )}
        </>
      )}
    </Grid>
  );
};
export default AttachedFiles;
